import { ArrowDropDown } from "@mui/icons-material";
import { Menu, MenuItem } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { PIC } from "@ryde/assets";
import {
  AuditLogExportScopes,
  DATA_E2E_KEY,
  TAuditLogExportScope,
} from "@ryde/shared";

import { useSearchSectionExport } from "./use-search-section-export";

interface ISearchSectionExportProps {
  allCount: number;
  filteredCount: number;
  onExport: (scope: TAuditLogExportScope) => void;
}

/** A labelled button that offers exporting every record or only those the search and filters leave. */
export const SearchSectionExport: FC<ISearchSectionExportProps> = ({
  allCount,
  filteredCount,
  onExport,
}) => {
  const { t } = useTranslation();
  const { anchorElement, isOpen, onOpen, onClose, onSelect } =
    useSearchSectionExport(onExport);

  return (
    <>
      <button
        type="button"
        className="search-section__export"
        aria-haspopup="menu"
        aria-expanded={isOpen}
        onClick={onOpen}
        {...{ [DATA_E2E_KEY]: "search-section-export-button" }}
      >
        <PIC.DownloadSVG />
        {t("general.download")}
        <ArrowDropDown />
      </button>
      <Menu anchorEl={anchorElement} open={isOpen} onClose={onClose}>
        <MenuItem onClick={() => onSelect(AuditLogExportScopes.filtered)}>
          {t("auditLog.export.filtered", { amount: filteredCount })}
        </MenuItem>
        <MenuItem onClick={() => onSelect(AuditLogExportScopes.all)}>
          {t("auditLog.export.all", { amount: allCount })}
        </MenuItem>
      </Menu>
    </>
  );
};
